import dynamic from 'next/dynamic'
import React, { FC, useMemo } from 'react'

import Step1Icon from '@material-ui/icons/Receipt'

import { WizardProps } from '~/components/shared/Wizard/types'
import WizardForm from '~/components/shared/Wizard/WizardForm'

import Step2Icon from '~/assets/icons/step1.svg?sprite'
import Step3Icon from '~/assets/icons/step2.svg?sprite'
import Step4Icon from '~/assets/icons/step3.svg?sprite'

import TemporaryStep from './steps/TemporaryStep'

const DealerPackageStep = dynamic(() =>
  import('./steps/DealerContactStep/DealerPackageStep')
)
const DealerInformationStep = dynamic(() =>
  import('./steps/DealerInformationStep')
)
const DealerContactStep = dynamic(() => import('./steps/DealerContactStep'))
const DealerCheckoutStep = dynamic(() => import('./steps/DealerCheckoutStep'))

const DealerForm: FC<WizardProps> = ({ edit, paid, isLoading, form }) => {
  const steps = useMemo(
    () =>
      [
        (!edit || (edit && !paid && !isLoading)) && {
          name: 'Packages',
          icon: <Step1Icon width={26} height={26} />,
          component: DealerPackageStep
        },
        {
          name: 'Information',
          icon: <Step2Icon width={26} height={26} />,
          component: isLoading ? TemporaryStep : DealerInformationStep
        },
        {
          name: 'Contact',
          icon: <Step3Icon width={26} height={26} />,
          component: DealerContactStep
        },
        (!edit || (edit && !paid)) && {
          name: 'Checkout',
          icon: <Step4Icon width={26} height={26} />,
          component: DealerCheckoutStep
        }
      ].filter(Boolean),
    [paid]
  )

  return <WizardForm form={form} edit={edit} steps={steps} paid={paid} />
}

export default DealerForm
